/**
 * BBCode exclusivo del códice de sistemas de juego.
 * Solo se registra en ViewRoleSystem y en el editor admin de RoleSystems.
 */

const TABLE_ROW_SEP = /\r\n|\r|\n/

function parseTableRows(content) {
  return String(content || '')
    .trim()
    .split(TABLE_ROW_SEP)
    .map((row) => row.trim())
    .filter(Boolean)
    .map((row) => row.split('|').map((cell) => cell.trim()))
}

export const roleSystemTableTag = {
  name: 'table',
  config: {
    transform: (content) => {
      const rows = parseTableRows(content)
      if (!rows.length) return ''

      const [headRow, ...bodyRows] = rows
      let html =
        '<div class="role-system-table-wrap"><table class="role-system-table"><thead><tr>'

      headRow.forEach((cell) => {
        html += `<th scope="col">${cell}</th>`
      })
      html += '</tr></thead>'

      if (bodyRows.length) {
        html += '<tbody>'
        bodyRows.forEach((cells) => {
          html += '<tr>'
          cells.forEach((cell) => {
            html += `<td>${cell}</td>`
          })
          html += '</tr>'
        })
        html += '</tbody>'
      }

      html += '</table></div>'
      return html
    },
    priority: 6,
  },
}

/** Definiciones para parseBBCode(..., roleSystemBbCodeTags) y BBCodeEditor customTags */
export const roleSystemBbCodeTags = [roleSystemTableTag]

export const ROLE_SYSTEM_TABLE_TEMPLATE = `[table]
Columna A | Columna B | Columna C
Valor 1 | Valor 2 | Valor 3
[/table]`
